module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/discovery-ui/images/canadian-example-check-b728c55bdab08d60b12a4776634cee1f.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/discovery-ui/images/canadian-example-check.png
// module id = 9URM
// module chunks = 24